export default {
  name: 'DashboardTitle',
  props: {
    context: Object,
    title: String,
    styleConfig: Object
  },

  computed: {
    label () {
      return this.$t(this.title, this.context)
    },

    styleClasses () {
      const styles = []
      const decorations = this.styleConfig || {}
      for (const style in decorations) {
        const decoration = decorations[style] // appendiamo le classi css, per ora senza gestione logiche
        styles.push(decoration)
      }

      return styles.join(' ')
    }
  }
}
